




















import {
  Component, Prop, PropSync, Vue,
} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Overlay from '@/components/Overlay/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';
import PermissionMixin from '../../../mixins/PermissionMixin';

@Component({
  components: {
    Overlay,
    PrimaryButton,
    TextButton,
  },
})
export default class DeleteDocument extends mixins(PermissionMixin) {
  @PropSync('dialog', {}) dialogSync!: boolean;

  @Prop({}) fileName!: string;

  public onDelete() {
    this.$emit('delete');
  }

  public onCancel() {
    this.dialogSync = false;
    this.$emit('cancel');
  }
}
